module.exports = __webpack_public_path__ + "static/media/Site1.e12696cd.png";